if (!customElements.get('cart-property-validation')) {
  class CartPropertyValidation extends HTMLElement {
  constructor() {
      super();
      this.cartValidationConfiguration = JSON.parse(this.querySelector('[data-cart-property-validation]').innerText);
      if (this.cartValidationConfiguration.cartIsInvalid) {
        window.location.href = "".concat(window.routes.cartUrl, "/clear");
      }
      this.checkPrices();
    }
    
    checkPrices = async () => {
      
      const url = new URL(window.location.href);
      const params = url.searchParams;
      
      if (params.has('reloaded')) return;
      
      const data = await fetch('/cart.js');
      const cart = await data.json();
      
      const items = cart.items.map(item => {
        return {
          id: item.id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          line_price: item.line_price,
          properties: item.properties
        }
      });
      
      const hasInvalidItems = items.some(item => item.line_price == 99999999);
      
      if (hasInvalidItems) {
        document.cookie = "cart=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        await fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
              items: items.map(item => {
                return {
                  quantity: item.quantity,
                  id: item.variant_id,
                  properties: item.properties
                }
              })
          }),
          headers: {
              'Content-Type': 'application/json'
          },
          referrer: 'no-referrer'
        }).then((response) => {
            window.location.href = '/cart?reloaded=true';
        })
      }
      
    } 
  }

  customElements.define('cart-property-validation', CartPropertyValidation);
}